import {API_PASSPORT} from './api-passport'
import {AVATARS} from './avatars'
import {YA_AUTHPROXY} from './ya-authproxy'

export const TESTING = {
  AVATARS,
  YA_AUTHPROXY,
  API_PASSPORT,
}
